"use client"

import { staticLabelsPLP } from "../helper"

const CompareStatus = ({
  displayCompare,
  plpCompareData,
  handleCompareProduct,
  handleRemoveCompareProduct,
  locale = "en",
}) => {
  if (!displayCompare) return null
  return (
    <>
      {typeof window !== "undefined" &&
      JSON.parse(localStorage.getItem("compareProducts"))?.some(
        item =>
          item?.compareMappedValues?.skuId ===
          plpCompareData?.compareMappedValues?.skuId
      ) ? (
        <button
          onClick={handleRemoveCompareProduct}
          className="compare-add compare-button-tile"
        >
          {staticLabelsPLP[locale].removeFromCompare}
        </button>
      ) : (
        <button
          onClick={handleCompareProduct}
          className="compare-add compare-button-tile"
        >
          {staticLabelsPLP[locale]?.addToCompareLabel}
        </button>
      )}
      <a className="compare-removes compare-button-tile">
        {staticLabelsPLP[locale]?.removeProduct}
      </a>
    </>
  )
}

export default CompareStatus
